import React, { useState, useEffect, useMemo} from 'react';
import { IMaskInput } from 'react-imask';
import { AutoComplete, Segmented } from 'antd';
import {useTheme} from "../header/Header";
import { correctNumber } from "../crm/feedback";
import {GoogleIcon, YandexIcon} from "../utils/Icons";
import {fetchRequestFeedback} from "../../api/crm/feedback";
import {
    authGoogle,
    authYandex,
    logout
} from "../header/Header";
import {AlertNoCancel, defenseFromManyRequest} from "../crm/feedback";
import "../../css/silos/silosConfigurator.css";

// Данные из таблицы
const silosData = [
    { id: 1, sheet: "BAF2400-26.76.90", profile: "BPF2420-26.76.90", volume: 26, diameter: 2400, totalHeight: 7600, cylinderHeight: 5500 },
    { id: 2, sheet: "BAF2400-40.108.90", profile: "BPF2420-40.108.90", volume: 40, diameter: 2400, totalHeight: 10750, cylinderHeight: 8450 },
    { id: 3, sheet: "BAF2400-48.126.90", profile: "BPF2420-48.126.90", volume: 48, diameter: 2400, totalHeight: 12600, cylinderHeight: 10500 },
    { id: 4, sheet: "BAF2400-60.151.90", profile: "BPF2420-60.151.90", volume: 60, diameter: 2400, totalHeight: 15100, cylinderHeight: 13000 },
    { id: 5, sheet: "BAF2400-70.176.90", profile: "BPF2420-70.176.90", volume: 70, diameter: 2400, totalHeight: 17600, cylinderHeight: 15500 },
    { id: 6, sheet: "BAF3000-40.75.90", profile: "BPF3000-40.75.90", volume: 40, diameter: 3000, totalHeight: 7500, cylinderHeight: 5100 },
    { id: 7, sheet: "BAF3000-55.100.90", profile: "BPF3000-55.100.90", volume: 55, diameter: 3000, totalHeight: 10000, cylinderHeight: 7600 },
    { id: 8, sheet: "BAF3000-65.113.90", profile: "BPF3000-65.113.90", volume: 65, diameter: 3000, totalHeight: 11250, cylinderHeight: 8850 },
    { id: 9, sheet: "BAF3000-75.125.90", profile: "BPF3000-75.125.90", volume: 75, diameter: 3000, totalHeight: 12500, cylinderHeight: 10100 },
    { id: 10, sheet: "BAF3000-83.138.90", profile: "BPF3000-83.138.90", volume: 83, diameter: 3000, totalHeight: 13750, cylinderHeight: 11350 },
    { id: 11, sheet: "BAF3000-90.150.90", profile: "BPF3000-90.150.90", volume: 90, diameter: 3000, totalHeight: 15000, cylinderHeight: 12600 },
    { id: 12, sheet: "BAF3000-100.163.90", profile: "BPF3000-100.163.90", volume: 100, diameter: 3000, totalHeight: 16250, cylinderHeight: 13850 },
    { id: 13, sheet: "BAF3000-110.175.90", profile: "BPF3000-110.175.90", volume: 110, diameter: 3000, totalHeight: 17500, cylinderHeight: 15100 },
    { id: 14, sheet: "BAF3000-125.200.90", profile: "BPF3000-125.200.90", volume: 125, diameter: 3000, totalHeight: 20000, cylinderHeight: 17600 },
    { id: 15, sheet: "BAF3500-53.75.90", profile: "BPF3500-53.75.90", volume: 53, diameter: 3500, totalHeight: 7500, cylinderHeight: 4900 },
    { id: 16, sheet: "BAF3500-65.88.90", profile: "BPF3500-65.88.90", volume: 65, diameter: 3500, totalHeight: 8750, cylinderHeight: 6150 },
    { id: 17, sheet: "BAF3500-80.108.90", profile: "BPF3500-80.108.90", volume: 80, diameter: 3500, totalHeight: 10750, cylinderHeight: 7500 },
    { id: 18, sheet: "BAF3500-100.125.90", profile: "BPF3500-100.125.90", volume: 100, diameter: 3500, totalHeight: 12500, cylinderHeight: 9900 },
    { id: 19, sheet: "BAF3500-125.150.90", profile: "BPF3500-125.150.90", volume: 125, diameter: 3500, totalHeight: 15000, cylinderHeight: 12400 },
    { id: 20, sheet: "BAF3500-150.175.90", profile: "BPF3500-150.175.90", volume: 150, diameter: 3500, totalHeight: 17500, cylinderHeight: 15200 },
    { id: 21, sheet: "BAF3500-175.200.90", profile: "BPF3500-175.200.90", volume: 175, diameter: 3500, totalHeight: 20000, cylinderHeight: 17500 },
    { id: 22, sheet: "BAF3500-200.225.90", profile: "BPF3500-200.225.90", volume: 200, diameter: 3500, totalHeight: 22520, cylinderHeight: 20200 },
    { id: 23, sheet: "BAF3500-221.250.90", profile: "BPF3500-221.250.90", volume: 221, diameter: 3500, totalHeight: 25000, cylinderHeight: 22400 },
    { id: 24, sheet: "BAF3500-245.275.90", profile: "BPF3500-245.275.90", volume: 245, diameter: 3500, totalHeight: 27500, cylinderHeight: 24900 },
    { id: 25, sheet: null, profile: "BPF4000-102.100.90", volume: 102, diameter: 4000, totalHeight: 10000, cylinderHeight: 7450 },
    { id: 26, sheet: null, profile: "BPF4000-126.120.90", volume: 126, diameter: 4000, totalHeight: 12000, cylinderHeight: 9450 },
    { id: 27, sheet: null, profile: "BPF4000-151.140.90", volume: 151, diameter: 4000, totalHeight: 14000, cylinderHeight: 11450 },
    { id: 28, sheet: null, profile: "BPF4000-176.160.90", volume: 176, diameter: 4000, totalHeight: 16000, cylinderHeight: 13450 },
    { id: 29, sheet: null, profile: "BPF4000-202.180.90", volume: 202, diameter: 4000, totalHeight: 18000, cylinderHeight: 15450 },
    { id: 30, sheet: null, profile: "BPF4000-227.200.90", volume: 227, diameter: 4000, totalHeight: 20000, cylinderHeight: 17450 },
    { id: 31, sheet: null, profile: "BPF4000-252.220.90", volume: 252, diameter: 4000, totalHeight: 22000, cylinderHeight: 19450 },
    { id: 32, sheet: null, profile: "BPF4000-277.240.90", volume: 277, diameter: 4000, totalHeight: 24000, cylinderHeight: 21450 },
];

export const russianCities = [
    'Москва', 'Санкт-Петербург', 'Новосибирск', 'Екатеринбург', 'Казань',
    'Нижний Новгород', 'Челябинск', 'Омск', 'Самара', 'Ростов-на-Дону',
    'Уфа', 'Красноярск', 'Пермь', 'Воронеж', 'Волгоград',
    'Краснодар', 'Саратов', 'Тюмень', 'Тольятти', 'Ижевск',
    'Барнаул', 'Ульяновск', 'Иркутск', 'Хабаровск', 'Ярославль',
    'Владивосток', 'Махачкала', 'Томск', 'Оренбург', 'Кемерово',
    'Новокузнецк', 'Рязань', 'Астрахань', 'Набережные Челны', 'Пенза',
    'Липецк', 'Киров', 'Чебоксары', 'Калининград', 'Тула',
    'Курск', 'Ставрополь', 'Сочи', 'Тверь', 'Магнитогорск',
    'Иваново', 'Брянск', 'Белгород', 'Сургут', 'Владимир',
    'Архангельск', 'Чита', 'Смоленск', 'Саранск', 'Курган',
    'Комсомольск-на-Амуре', 'Орёл', 'Вологда', 'Якутск', 'Мурманск',
    'Тамбов', 'Владикавказ', 'Грозный', 'Йошкар-Ола', 'Сыктывкар',
    'Петрозаводск', 'Улан-Удэ', 'Абакан', 'Горно-Алтайск', 'Благовещенск',
    'Норильск', 'Ханты-Мансийск', 'Салехард', 'Анадырь', 'Псков',
    'Великий Новгород', 'Кострома', 'Севастополь', 'Симферополь', 'Керчь',
    // Добавленные города (до 250)
    'Азов', 'Александров', 'Алексин', 'Альметьевск', 'Анапа',
    'Ангарск', 'Апатиты', 'Арзамас', 'Армавир', 'Арсеньев',
    'Артём', 'Асбест', 'Ачинск', 'Балаково', 'Балашиха',
    'Балашов', 'Батайск', 'Белебей', 'Белово', 'Белогорск',
    'Белорецк', 'Белореченск', 'Бердск', 'Березники', 'Берёзовский',
    'Бийск', 'Биробиджан', 'Бор', 'Борисоглебск', 'Братск',
    'Бугульма', 'Будённовск', 'Бузулук', 'Буйнакск', 'Великие Луки',
    'Волгодонск', 'Волжск', 'Волжский', 'Воркута', 'Воткинск',
    'Всеволожск', 'Выборг', 'Выкса', 'Вязьма', 'Гатчина',
    'Геленджик', 'Георгиевск', 'Глазов', 'Губкин', 'Гудермес',
    'Гуково', 'Гусь-Хрустальный', 'Дербент', 'Дзержинск', 'Димитровград',
    'Дмитров', 'Долгопрудный', 'Домодедово', 'Донской', 'Дубна',
    'Егорьевск', 'Ейск', 'Елабуга', 'Елец', 'Ессентуки',
    'Железногорск', 'Жигулёвск', 'Жуковский', 'Заволжье', 'Заинск',
    'Заречный', 'Зеленоград', 'Зеленодольск', 'Златоуст', 'Ивантеевка',
    'Избербаш', 'Искитим', 'Истра', 'Ишим', 'Калуга',
    'Каменск-Уральский', 'Каменск-Шахтинский', 'Камышин', 'Канск', 'Карабулак',
    'Карачаевск', 'Карпинск', 'Каспийск', 'Кинешма', 'Кириши',
    'Кирово-Чепецк', 'Киселёвск', 'Кисловодск', 'Клин', 'Клинцы',
    'Ковров', 'Когалым', 'Коломна', 'Копейск', 'Королёв',
    'Котлас', 'Красногорск', 'Краснокаменск', 'Краснотурьинск', 'Кропоткин',
    'Крымск', 'Кстово', 'Кузнецк', 'Кумертау', 'Кунгур',
    'Кызыл', 'Лабинск', 'Лангепас', 'Лебедянь', 'Лениногорск',
    'Ленинск-Кузнецкий', 'Лиски', 'Лобня', 'Лысьва', 'Лыткарино',
    'Люберцы', 'Магадан', 'Майкоп', 'Междуреченск', 'Мелеуз',
    'Миасс', 'Минеральные Воды', 'Минусинск', 'Михайловка', 'Михайловск',
    'Можайск', 'Муром', 'Мытищи', 'Назрань', 'Нальчик',
    'Наро-Фоминск', 'Находка', 'Невинномысск', 'Нерюнгри', 'Нефтекамск',
    'Нефтеюганск', 'Нижневартовск', 'Нижнекамск', 'Нижний Тагил', 'Новоалтайск',
    'Нововоронеж', 'Новокуйбышевск', 'Новомосковск', 'Новороссийск', 'Новотроицк',
    'Новоуральск', 'Новочебоксарск', 'Новочеркасск', 'Новошахтинск', 'Ногинск',
    'Ноябрьск', 'Нягань', 'Обнинск', 'Одинцово', 'Озёрск',
    'Октябрьский', 'Орехово-Зуево', 'Орск', 'Павлово', 'Павловский Посад',
    'Первоуральск', 'Переславль-Залесский', 'Подольск', 'Полевской', 'Прокопьевск',
    'Прохладный', 'Пушкино', 'Пятигорск', 'Раменское', 'Ревда',
    'Реутов', 'Ржев', 'Рославль', 'Рубцовск', 'Рыбинск',
    'Салават', 'Сальск', 'Сарапул', 'Саров', 'Свободный',
    'Северодвинск', 'Североморск', 'Северск', 'Сергиев Посад', 'Серов',
    'Серпухов', 'Сертолово', 'Сестрорецк', 'Славянск-на-Кубани', 'Снежинск',
    'Соликамск', 'Солнечногорск', 'Сосновый Бор', 'Старый Оскол', 'Стерлитамак',
    'Стрежевой', 'Ступино', 'Суздаль', 'Сызрань', 'Таганрог',
    'Тимашёвск', 'Тихвин', 'Тихорецк', 'Тобольск', 'Торжок',
    'Тосно', 'Троицк', 'Туапсе', 'Туймазы', 'Уварово',
    'Углич', 'Урус-Мартан', 'Усолье-Сибирское', 'Уссурийск', 'Усть-Илимск',
    'Ухта', 'Феодосия', 'Фрязино', 'Химки', 'Черемхово',
    'Череповец', 'Черкесск', 'Черногорск', 'Чехов', 'Чистополь',
    'Шадринск', 'Шали', 'Шахты', 'Шелехов', 'Электросталь',
    'Элиста', 'Энгельс', 'Южно-Сахалинск', 'Юрга', 'Ялта'
];

// const silosTypes = [
//     { id: 'storage', label: 'Бункерный силос', icon: '🏭' },
//     { id: 'loading', label: 'Погрузочный силос', icon: '📦' },
//     { id: 'multichamber', label: 'Многокамерный силос', icon: '🧱' },
//     { id: 'internal', label: 'Внутренний силос (для помещений)', icon: '🏠' },
// ];

// Компонент визуализации (SVG)
function SilosVisualization({ diameter, cylinderHeight, totalHeight, type, angle, showRealValues, supportType, material }) {
    // --- Параметры геометрии ---
    const roofAngleDeg = 15;
    const topCone = (diameter / 2) * Math.tan(roofAngleDeg * Math.PI / 180);
    const funnelHeight = (diameter / 2) / Math.tan(angle * Math.PI / 360);
    const overallHeight = cylinderHeight + topCone + funnelHeight;

    // --- Размеры холста SVG ---
    const W = 300, H = 450;
    const cx = W / 2;
    const padX = 40, padY = 45;
    const availH = H - padY * 2;
    const availW = W - padX * 2;
    const scale = Math.min(availH / overallHeight, availW / diameter);

    // --- Расчёт координат ---
    const bw = diameter * scale;
    const ch = topCone * scale;
    const bh = cylinderHeight * scale;
    const fh = funnelHeight * scale;
    const totalPx = ch + bh + fh;
    const y0 = padY + (availH - totalPx) / 2;
    const y1 = y0 + ch;
    const y2 = y1 + bh;
    const y3 = y2 + fh;
    const hw = bw / 2;
    const topWidth = hw * 0.2;

    // --- Швы ---
    const numStripes = 6;
    const stripePositions = [];
    if (numStripes > 0 && bh > 0) {
        const step = bh / (numStripes + 1);
        for (let i = 1; i <= numStripes; i++) {
            stripePositions.push(y1 + step * i);
        }
    }

    // --- Вспомогательные отрисовки ---
    const renderLegs = () => {
        if (type === 'internal') {
            const legWidth = 6, legHeight = 20;
            return (
                <>
                    <rect x={cx - hw + 5} y={y3 + 2} width={legWidth} height={legHeight} fill="#3A5272" rx={2} />
                    <rect x={cx - hw/2 - legWidth/2} y={y3 + 2} width={legWidth} height={legHeight} fill="#3A5272" rx={2} />
                    <rect x={cx + hw/2 - legWidth/2} y={y3 + 2} width={legWidth} height={legHeight} fill="#3A5272" rx={2} />
                    <rect x={cx + hw - 5 - legWidth} y={y3 + 2} width={legWidth} height={legHeight} fill="#3A5272" rx={2} />
                </>
            );
        }
        return null;
    };

    const renderLoadingScrew = () => {
        if (type === 'loading') {
            return <path d={`M ${cx - hw} ${y1 + bh/2} L ${cx - hw - 20} ${y1 + bh/2 - 10}`} stroke="#f06a00" strokeWidth="2" />;
        }
        return null;
    };

    // --- Отображение размеров ---
    const displayHeight = showRealValues ? `${(cylinderHeight / 1000).toFixed(1)} м` : 'X м';
    const displayDiameter = showRealValues ? `${(diameter / 1000).toFixed(1)} м` : 'X м';
    const displayAngle = showRealValues ? `${angle}°` : 'X°';

    // --- Высота корпуса (зависит от опоры) ---
    const bodyHeight = (supportType === 'short_skirt') ? bh : (bh + fh + 20);

    // --- Выбор градиентов по материалу ---
    let bodyGradient, topGradient;

    if (material === 'aluminum') {
        bodyGradient = 'url(#g-body-aluminum)';
        topGradient = 'url(#g-top-aluminum)';
    } else if (material === 'steel') {
        bodyGradient = 'url(#g-body-steel)';
        topGradient = 'url(#g-top-steel)';
    } else if (material === 'profile') {
        bodyGradient = 'url(#g-body-profile)';
        topGradient = 'url(#g-top-profile)';
    } else {
        // fallback
        bodyGradient = 'url(#g-body-aluminum)';
        topGradient = 'url(#g-top-aluminum)';
    }

    return (
        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: '100%' }}>
            <defs>
                {/* Алюминий */}
                <linearGradient id="g-body-aluminum" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#1A2840" />
                    <stop offset="38%" stopColor="#2C3E5C" />
                    <stop offset="72%" stopColor="#213450" />
                    <stop offset="100%" stopColor="#111E2E" />
                </linearGradient>
                <linearGradient id="g-top-aluminum" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#152036" />
                    <stop offset="45%" stopColor="#253A56" />
                    <stop offset="100%" stopColor="#0E1826" />
                </linearGradient>

                {/* Нержавеющая сталь */}
                <linearGradient id="g-body-steel" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#3A4048" />
                    <stop offset="38%" stopColor="#5A6068" />
                    <stop offset="72%" stopColor="#4A5058" />
                    <stop offset="100%" stopColor="#2A3038" />
                </linearGradient>
                <linearGradient id="g-top-steel" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#30363E" />
                    <stop offset="45%" stopColor="#505660" />
                    <stop offset="100%" stopColor="#20262E" />
                </linearGradient>

                {/* Экструдированный профиль */}
                <linearGradient id="g-body-profile" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#0E1E30" />
                    <stop offset="38%" stopColor="#1A3050" />
                    <stop offset="72%" stopColor="#142840" />
                    <stop offset="100%" stopColor="#081420" />
                </linearGradient>
                <linearGradient id="g-top-profile" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#081828" />
                    <stop offset="45%" stopColor="#142840" />
                    <stop offset="100%" stopColor="#040C18" />
                </linearGradient>
            </defs>

            {/* Крыша */}
            <polygon
                points={`${cx - topWidth},${y0} ${cx + topWidth},${y0} ${cx + hw},${y1} ${cx - hw},${y1}`}
                fill={topGradient} stroke="#3A5272" strokeWidth="1" strokeLinejoin="round"
            />
            {/* Люк сверху */}
            <rect
                x={cx - topWidth * 0.5} y={y0 - 10}
                width={topWidth} height={10}
                fill="#0A1420" stroke="#3A5272" strokeWidth="0.8" rx={2}
            />

            {/* Корпус */}
            <rect
                x={cx - hw} y={y1}
                width={bw} height={bodyHeight}
                fill={bodyGradient} fillOpacity="0.35"
                stroke="#3A5272" strokeWidth="1"
            />

            {/* Швы */}
            {stripePositions.map((sy, i) => (
                <line key={i} x1={cx - hw} y1={sy} x2={cx + hw} y2={sy}
                      stroke="#3A5272" strokeWidth="0.7" />
            ))}

            {/* Блик */}
            <line
                x1={cx - hw + 3} y1={y1 + 6} x2={cx - hw + 3} y2={y2 - 6}
                stroke="rgba(255,255,255,0.055)" strokeWidth="2.5"
            />

            {/* Поверхность для короткой юбки */}
            {supportType === 'short_skirt' && (
                <rect
                    x={cx - 0.9 * bw}
                    y={y2 - 5}
                    width={1.8 * bw}
                    height={5}
                    fill="#3A5272"
                    opacity="0.8"
                    stroke="#2A3A4A"
                    strokeWidth="1"
                />
            )}

            {/* Внутренний конус */}
            <polygon
                points={`${cx - hw},${y2} ${cx + hw},${y2} ${cx},${y3}`}
                fill="#f06a00" fillOpacity="0.5"
                stroke="#3A5272" strokeWidth="1" strokeLinejoin="round"
            />

            {/* Линия дна цилиндра (пунктир) */}
            <line
                x1={cx - hw} y1={y2} x2={cx + hw} y2={y2}
                stroke="#3A5272" strokeWidth="1.5" strokeDasharray="4,4"
            />

            {renderLegs()}
            {renderLoadingScrew()}

            {/* Дуга угла */}
            {fh > 8 && (
                <>
                    {(() => {
                        const R = Math.min(hw, fh) * 0.25;
                        const halfAngleRad = (angle / 2) * Math.PI / 180;
                        const startX = cx - R * Math.sin(halfAngleRad);
                        const startY = y3 - R * Math.cos(halfAngleRad);
                        const endX = cx + R * Math.sin(halfAngleRad);
                        const endY = y3 - R * Math.cos(halfAngleRad);
                        const pathD = `M ${startX} ${startY} A ${R} ${R} 0 0 1 ${endX} ${endY}`;
                        return (
                            <>
                                <path d={pathD} stroke="#f06a00" strokeWidth="1.5" fill="none" />
                                <text x={cx} y={y3 - R - 8} textAnchor="middle" fill="#f06a00" fontSize="10" fontFamily="CorporateSCon-Bold">
                                    {displayAngle}
                                </text>
                            </>
                        );
                    })()}
                </>
            )}

            {/* Размерная линия высоты */}
            {bh > 15 && (
                <>
                    <line x1={cx - hw - 16} y1={y1} x2={cx - hw - 16} y2={y2} stroke="#f06a00" strokeWidth="1" />
                    <line x1={cx - hw - 12} y1={y1} x2={cx - hw - 20} y2={y1} stroke="#f06a00" strokeWidth="1" />
                    <line x1={cx - hw - 12} y1={y2} x2={cx - hw - 20} y2={y2} stroke="#f06a00" strokeWidth="1" />
                    <text x={cx - hw - 40} y={(y1 + y2) / 2 - 4} textAnchor="middle" fill="#f06a00" fontSize="13" fontFamily="CorporateSCon-Bold">Высота:</text>
                    <text x={cx - hw - 40} y={(y1 + y2) / 2 + 10} textAnchor="middle" fill="#f06a00" fontSize="13" fontFamily="CorporateSCon-Bold">{displayHeight}</text>
                </>
            )}

            {/* Размерная линия диаметра */}
            {bw > 20 && (
                <>
                    <line x1={cx - hw} y1={y3 + 25} x2={cx + hw} y2={y3 + 25} stroke="#f06a00" strokeWidth="1" />
                    <line x1={cx - hw} y1={y3 + 22} x2={cx - hw} y2={y3 + 28} stroke="#f06a00" strokeWidth="1" />
                    <line x1={cx + hw} y1={y3 + 22} x2={cx + hw} y2={y3 + 28} stroke="#f06a00" strokeWidth="1" />
                    <text x={cx} y={y3 + 42} textAnchor="middle" fill="#f06a00" fontSize="13" fontFamily="CorporateSCon-Bold">Диаметр: {displayDiameter}</text>
                </>
            )}
        </svg>
    );
}

// Основной компонент
export function ConfiguratorSilos() {
    const { theme } = useTheme();

    // Состояния
    const [step, setStep] = useState(1);
    const [material, setMaterial] = useState(null);
    const [supportType, setSupportType] = useState(null);
    const [selectedDiameter, setSelectedDiameter] = useState(null);
    const [selectedVolume, setSelectedVolume] = useState(null);
    const [selectedAngle, setSelectedAngle] = useState(90);
    const [accessories, setAccessories] = useState([]);
    const [densityGroup, setDensityGroup] = useState('01');
    const [hasVisitedStep3, setHasVisitedStep3] = useState(false);
    const [hasVisitedStep4, setHasVisitedStep4] = useState(false);

    // Состояния для формы заявки
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        city: '',
        organization: '',
        comment: ''
    });
    const [inputFillCheck, setInputFillCheck] = useState(false);
    const [showAutorisationForm, setShowAutorisationForm] = useState(false);
    const [quantity, setQuantity] = useState(1);

    // Состояния для отправки и уведомлений
    const [loadManyRequest, setLoadManyRequest] = useState(false);
    const [showAlertNoCancel, setShowAlertNoCancel] = useState(false);
    const [alertNoCancelParams, setAlertNoCancelParams] = useState({
        tittle: "Ошибка",
        buttonText: "выйти",
        message: "",
        function: null,
        arguments: null,
    });

    // Состояния для автодополнения города
    const [cityOptions, setCityOptions] = useState([]);

    // Данные
    const materials = [
        { id: 'aluminum', label: 'Алюминий', code: 'A', desc: ['Коррозионная стойкость', 'малый вес', 'долговечность'] },
        { id: 'steel', label: 'Нержавеющая сталь', code: 'S', desc: ['Для агрессивных сред и пищевых продуктов', 'высокая прочность'] },
        { id: 'profile', label: 'Экструдированный алюминиевый профиль', code: 'P', desc: ['Повышенная прочность', 'минимальный вес', 'инновационная технология'] },
    ];

    const supportTypes = [
        { id: 'long_skirt', label: 'Длинная юбка', type: 'storage', desc: 'Устойчивая опора для бункерных силосов' },
        { id: 'short_skirt', label: 'Короткая юбка', type: 'storage', desc: 'Компактная опора для бункерных силосов' },
        { id: 'custom_skirt', label: 'Опоры / Скерт по проекту', type: 'loading', disabled: true, desc: 'Индивидуальное решение для погрузочных силосов' },
    ];

    const accessoryOptions = [
        { id: 'tensometry', label: 'Тензометрия' },
        { id: 'ladders', label: 'Лестницы' },
        { id: 'railings', label: 'Ограждения' },
        { id: 'flanges', label: 'Фланцы' },
        { id: 'sensors', label: 'Датчики' },
    ];

    // --- Логика выбора модели ---
    const diameters = useMemo(() => {
        const unique = [...new Set(silosData.map(item => item.diameter))];
        return unique.sort((a, b) => a - b);
    }, []);

    const availableVolumes = useMemo(() => {
        if (!selectedDiameter) return [];
        const items = silosData.filter(item => item.diameter === selectedDiameter);
        return items.map(item => item.volume).sort((a, b) => a - b);
    }, [selectedDiameter]);

    const selectedModel = useMemo(() => {
        if (!selectedDiameter || !selectedVolume) return null;
        return silosData.find(item => item.diameter === selectedDiameter && item.volume === selectedVolume);
    }, [selectedDiameter, selectedVolume]);

    // --- Автовыбор первого диаметра и объёма ---
    useEffect(() => {
        if (diameters.length > 0 && !selectedDiameter) {
            const firstDiameter = diameters[0];
            setSelectedDiameter(firstDiameter);
            const firstVolumes = silosData
                .filter(item => item.diameter === firstDiameter)
                .map(item => item.volume)
                .sort((a, b) => a - b);
            if (firstVolumes.length > 0) {
                setSelectedVolume(firstVolumes[0]);
            }
        }
    }, [diameters, selectedDiameter]);

    // --- Обновляем флаги посещения ---
    useEffect(() => {
        if (step >= 3) setHasVisitedStep3(true);
    }, [step]);

    useEffect(() => {
        if (step >= 4) setHasVisitedStep4(true);
    }, [step]);

    // --- Вычисляем, показывать ли реальные значения ---
    const showRealValues = step >= 3 || hasVisitedStep3;

    const handleVolumeChange = (e) => {
        const value = parseInt(e.target.value, 10);
        const closest = availableVolumes.reduce((prev, curr) => Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
        setSelectedVolume(closest);
    };

    // --- Обработчики полей формы ---
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        let processedValue = value;
        if (name === 'phone') {
            processedValue = correctNumber(value);
        }
        setFormData(prev => ({ ...prev, [name]: processedValue }));
        if (inputFillCheck) setInputFillCheck(false);
    };

    // --- Обработчики автодополнения города ---
    const handleCitySearch = (value) => {
        if (!value) {
            setCityOptions([]);
            return;
        }
        const filtered = russianCities.filter(city =>
            city.toLowerCase().includes(value.toLowerCase())
        );
        setCityOptions(filtered.map(city => ({ value: city })));
    };

    const handleCitySelect = (value) => {
        setFormData(prev => ({ ...prev, city: value }));
        if (inputFillCheck) setInputFillCheck(false);
        setCityOptions([]);
    };

    // --- Функция проверки невалидности поля ---
    const isFieldInvalid = (fieldName) => {
        if (!inputFillCheck) return false;
        if (fieldName === 'phone') {
            const phoneClean = formData.phone.replace(/\D/g, '');
            return formData.phone === '' || phoneClean.length !== 11;
        }
        return formData[fieldName] === '';
    };

    // --- Функция сборки текста заявки ---
    const buildMessage = () => {
        const parts = [];
        const modelName = getModelName();
        parts.push(`${modelName} - ${quantity} шт.`);

        const accessoriesText = accessories.length > 0
            ? accessories.map(id => {
                const opt = accessoryOptions.find(o => o.id === id);
                return opt ? opt.label : id;
            }).join(', ')
            : '';

        if (accessoriesText) {
            parts.push(`Комплектация: ${accessoriesText}.`);
        }
        if (formData.organization && formData.organization.trim() !== '') {
            parts.push(`Организация: ${formData.organization}.`);
        }
        if (formData.comment && formData.comment.trim() !== '') {
            parts.push(`Комментарий: ${formData.comment}.`);
        }
        return parts.join(' ');
    };

    // --- Обработчик отправки заявки ---
    const handleSubmitRequest = async () => {
        setInputFillCheck(true);

        const nameEmpty = formData.name.trim() === '';
        const cityEmpty = formData.city.trim() === '';
        const phoneClean = formData.phone.replace(/\D/g, '');
        const phoneInvalid = formData.phone === '' || phoneClean.length !== 11;

        if (nameEmpty || cityEmpty || phoneInvalid) {
            return;
        }

        const token = localStorage.getItem('token');
        if (!token) {
            setShowAutorisationForm(true);
            return;
        }

        defenseFromManyRequest(setLoadManyRequest, 2000);

        const messageText = buildMessage();

        const fields = {
            token: token,
            object: getModelName(),
            text: messageText,
            contactPhone: formData.phone,
            city: formData.city,
            name: formData.name,
        };
        //
        //
        // setAlertNoCancelParams({
        //     tittle: fields.object,
        //     buttonText: "продолжить",
        //     message: fields.text,
        //     function: null,
        //     arguments: null
        // });
        // setShowAlertNoCancel(true);

        try {
            let answer = await fetchRequestFeedback(fields);
            if (answer === `пользователь с таким токеном не найден\n`) {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "выйти",
                    message: answer,
                    function: logout,
                    arguments: null
                });
                setShowAlertNoCancel(true);
            } else if (answer === "many request\n") {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "продолжить",
                    message: "Разрешено отправлять не более одного вопроса раз в 30 минут",
                    function: null,
                    arguments: null
                });
                setShowAlertNoCancel(true);
            } else if (answer === "ok") {
                setAlertNoCancelParams({
                    tittle: "Сообщение",
                    buttonText: "продолжить",
                    message: "Ваш запрос успешно отправлен",
                    function: null,
                    arguments: null
                });
                setShowAlertNoCancel(true);
                setFormData({ name: '', phone: '', city: '', organization: '', comment: '' });
            }
        } catch (error) {
            console.log("error", error);
            if (error === "пользователь с таким токеном не найден") {
                setAlertNoCancelParams({
                    tittle: "Ошибка",
                    buttonText: "выйти",
                    message: error,
                    function: null,
                    arguments: null
                });
                setShowAlertNoCancel(true);
            }
        }
    };

    const currentVolumeValue = selectedVolume || (availableVolumes.length > 0 ? availableVolumes[0] : 0);
    const mass = '~7.0 т';

    // --- Навигация ---
    const goToNextStep = () => { if (step < 5) setStep(step + 1); };
    const goToPrevStep = () => { if (step > 1) setStep(step - 1); };

    const canAccessStep = (targetStep) => {
        if (targetStep === 1) return true;
        if (targetStep === 2) return material !== null;
        if (targetStep === 3) return material !== null && supportType !== null && supportType !== 'custom_skirt';
        if (targetStep === 4) return material !== null && supportType !== null && supportType !== 'custom_skirt' && selectedModel !== null;
        if (targetStep === 5) return material !== null && supportType !== null && supportType !== 'custom_skirt' && selectedModel !== null;
        return false;
    };

    const goToStep = (targetStep) => {
        if (canAccessStep(targetStep)) setStep(targetStep);
    };

    // --- Формирование названия модели ---
    const getModelName = () => {
        const anglePart = showRealValues ? String(selectedAngle) : 'XX';
        const densityPart = (step === 4 || hasVisitedStep4) ? densityGroup : 'XX';

        let materialPart = 'X';
        if (material) {
            const mat = materials.find(m => m.id === material);
            materialPart = mat ? mat.code : 'X';
        }

        let supportPart = 'X';
        if (supportType && supportType !== 'custom_skirt') {
            supportPart = (supportType === 'long_skirt' || supportType === 'short_skirt') ? 'F' : 'L';
        }

        let diameterPart = 'X';
        let volumePart = 'X';
        let heightPart = 'XX';
        if (showRealValues && selectedModel) {
            diameterPart = String(selectedModel.diameter);
            volumePart = String(selectedModel.volume);
            // Общая высота в дециметрах (целое число)
            heightPart = String(Math.round(selectedModel.totalHeight / 100));
        }

        return `B${materialPart}${supportPart}${diameterPart}-${volumePart}.${heightPart}.${anglePart}.${densityPart}.0000`;
    };

    // --- Определяем тип визуализации ---
    const getVisualizationType = () => {
        if (supportType === 'long_skirt' || supportType === 'short_skirt') return 'storage';
        if (supportType === 'custom_skirt') return 'loading';
        return 'storage';
    };

    // --- Рендер содержимого левой колонки (без навигации) ---
    const renderStep1 = () => (
        <div className="left-content silos-fade-in">
            <h1 className="page-title">Выберите материал</h1>
            <p className="page-subtitle">Из какого материала будет изготовлен силос</p>
            <div className="type-grid">
                {materials.map(mat => (
                    <button
                        key={mat.id}
                        onClick={() => setMaterial(mat.id)}
                        className={`type-card ${material === mat.id ? 'type-card-active' : ''}`}
                    >
                        <span className="type-label">{mat.label}</span>
                        <span className="type-desc">
                        <ul className="type-desc-list">
                            {mat.desc.map((item, i) => (
                                <li key={i}>
                                    <span className="bullet">•</span> {item}
                                </li>
                            ))}
                        </ul>
                    </span>
                    </button>
                ))}
            </div>
        </div>
    );

    const renderStep2 = () => (
        <div className="left-content silos-fade-in">
            <h1 className="page-title">Выберите тип опоры</h1>
            <p className="page-subtitle">Определите способ установки силоса</p>
            <div className="type-grid">
                {supportTypes.map(sup => (
                    <button
                        key={sup.id}
                        onClick={() => !sup.disabled && setSupportType(sup.id)}
                        className={`type-card ${supportType === sup.id ? 'type-card-active' : ''} ${sup.disabled ? 'type-card-disabled' : ''}`}
                        disabled={sup.disabled}
                    >
                        <span className="type-label">{sup.label}</span>
                        <span className="type-desc">{sup.desc}</span>
                        {sup.disabled && <span className="type-badge">скоро</span>}
                    </button>
                ))}
            </div>
        </div>
    );

    const renderStep3 = () => {
        const volMin = availableVolumes.length > 0 ? availableVolumes[0] : 0;
        const volMax = availableVolumes.length > 0 ? availableVolumes[availableVolumes.length - 1] : 100;

        const diameterSegments = diameters.map(d => ({
            value: d,
            label: `${d/1000} м`
        }));

        const getMarkOffset = (index, total) => {
            if (total <= 1) return 0;
            if (index === total - 1) return 0;
            const maxOffset = 10;
            const minOffset = 2;
            if (total === 2) return maxOffset;
            const step = (maxOffset - minOffset) / (total - 2);
            return maxOffset - step * index;
        };

        return (
            <div className="left-content silos-fade-in">
                <h1 className="page-title">Габариты</h1>
                <p className="page-subtitle">Диаметр и объём. Высота рассчитывается автоматически.</p>

                {/* Диаметр — Segmented */}
                <div className="param-group">
                    <label className="param-label">Диаметр</label>
                    <Segmented
                        options={diameterSegments}
                        value={selectedDiameter || diameters[0]}
                        onChange={(value) => {
                            const newDiameter = value;
                            setSelectedDiameter(newDiameter);
                            const firstVolumes = silosData
                                .filter(item => item.diameter === newDiameter)
                                .map(item => item.volume)
                                .sort((a, b) => a - b);
                            if (firstVolumes.length > 0) {
                                setSelectedVolume(firstVolumes[0]);
                            } else {
                                setSelectedVolume(null);
                            }
                        }}
                        block
                        className={`density-segmented ${theme}`}
                    />
                </div>

                {/* Объём — ползунок */}
                {selectedDiameter && availableVolumes.length > 0 && (
                    <div className="param-group">
                        <label className="param-label">Объём</label>
                        <div className="slider-wrapper">
                            <input
                                type="range"
                                min={volMin}
                                max={volMax}
                                step={1}
                                value={currentVolumeValue}
                                onChange={handleVolumeChange}
                                className="param-slider"
                            />
                            <div className="slider-marks-custom">
                                {availableVolumes.map((v, index) => {
                                    const percent = ((v - volMin) / (volMax - volMin)) * 100;
                                    const offset = getMarkOffset(index, availableVolumes.length);
                                    return (
                                        <span
                                            key={v}
                                            className="slider-mark-custom"
                                            style={{
                                                left: `calc(${percent}% + ${offset}px)`,
                                                transform: 'translateX(-50%)'
                                            }}
                                        >
                                        {v} м³
                                    </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="param-value">{currentVolumeValue} м³</div>
                    </div>
                )}

                {/* Угол раствора — Segmented (без растяжения) */}
                {selectedDiameter && (
                    <div className="param-group angle-options">
                        <label className="param-label">Угол раствора</label>
                        <Segmented
                            options={[
                                { value: 60, label: '60°' },
                                { value: 90, label: '90°' },
                            ]}
                            value={selectedAngle}
                            onChange={(value) => setSelectedAngle(value)}
                            className={`density-segmented angle-button ${theme}`}
                        />
                    </div>
                )}

                {selectedModel && (
                    <div className="calc-block">
                        <div className="calc-title">Расчётные параметры</div>
                        <div className="calc-grid">
                            <div className="calc-item">
                                <span className="calc-label">Высота цилиндра</span>
                                <span className="calc-value">{(selectedModel.cylinderHeight / 1000).toFixed(1)} м</span>
                            </div>
                            <div className="calc-item">
                                <span className="calc-label">Общая высота</span>
                                <span className="calc-value">{(selectedModel.totalHeight / 1000).toFixed(1)} м</span>
                            </div>
                            <div className="calc-item">
                                <span className="calc-label">Масса конструкции</span>
                                <span className="calc-value">{mass}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderStep4 = () => {
        const toggleAccessory = (id) => {
            setAccessories(prev =>
                prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
            );
        };

        const accessoryOptionsWithoutDensity = accessoryOptions.filter(opt => opt.id !== 'density_group');

        // Данные для Segmented
        const densitySegments = [
            { value: '01', range: '0–100' },
            { value: '02', range: '101–200' },
            { value: '03', range: '201–300' },
            { value: '04', range: '301–400' },
            { value: '05', range: '401–500' },
            { value: '06', range: '501–600' },
            { value: '07', range: '601–700' },
        ];

        return (
            <div className="left-content silos-fade-in">
                <h1 className="page-title">Комплектация</h1>
                <p className="page-subtitle">Выберите дополнительное оснащение силоса</p>

                <div className="param-group quantity-group">
                    <label className="param-label">Количество силосов</label>
                    <input
                        type="number"
                        min="1"
                        max="99"
                        value={quantity}
                        onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                        className="quantity-input"
                    />
                </div>

                {/* Группа плотности материала — Segmented вместо ползунка */}
                <div className="param-group density-group-full">
                    <label className="param-label">Группа плотности материала кг/м³</label>
                    <Segmented
                        options={densitySegments.map(item => ({
                            value: item.value,
                            label: (
                                <div className="density-segment-label">
                                    <span className="density-number">{item.value}</span>
                                    <span className="density-range">{item.range}</span>
                                </div>
                            )
                        }))}
                        value={densityGroup}
                        onChange={(value) => setDensityGroup(value)}
                        block
                        className={`density-segmented ${theme}`}
                    />
                </div>

                <div className="accessories-grid">
                    {accessoryOptionsWithoutDensity.map(opt => {
                        const isActive = accessories.includes(opt.id);
                        return (
                            <button
                                key={opt.id}
                                onClick={() => toggleAccessory(opt.id)}
                                className={`accessory-btn ${isActive ? 'accessory-btn-active' : ''}`}
                            >
                            <span className="accessory-checkbox">
                                {isActive && <span className="checkmark">✓</span>}
                            </span>
                                <span>{opt.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    };

    const renderStep5 = () => (
        <div className="left-content silos-fade-in">
            <h1 className="page-title">Заявка</h1>
            <p className="page-subtitle">Заполните контактные данные для получения коммерческого предложения</p>

            <div className="form-group">
                <label className="form-label">Имя</label>
                <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                    className={`form-input ${isFieldInvalid('name') ? 'feedbackFormRequiredFill' : ''}`}
                    placeholder="Введите ваше имя"
                />
            </div>

            <div className="form-group">
                <label className="form-label">Телефон</label>
                <IMaskInput
                    mask="+7 (000) 000-00-00"
                    value={formData.phone}
                    onAccept={(value, mask) => {
                        // value — отформатированная строка с маской, но нам нужен "сырой" номер
                        // Получаем только цифры
                        const digits = mask.unmaskedValue;
                        // Сохраняем в формате +7XXXXXXXXXX
                        if (digits.length === 0) {
                            setFormData(prev => ({ ...prev, phone: '' }));
                        } else {
                            setFormData(prev => ({ ...prev, phone: `+7${digits.slice(0, 10)}` }));
                        }
                        if (inputFillCheck) setInputFillCheck(false);
                    }}
                    placeholder="+7 (000) 000-00-00"
                    className={`form-input ${isFieldInvalid('phone') ? 'feedbackFormRequiredFill' : ''}`}
                />
            </div>

            {/* Остальные поля без изменений */}
            <div className="form-group">
                <label className="form-label">Город</label>
                <AutoComplete
                    className={`form-autocomplete ${theme} ${isFieldInvalid('city') ? 'feedbackFormRequiredFill' : ''}`}
                    classNames={{ popup: { root: `autocomplete-dropdown ${theme}` } }}
                    value={formData.city}
                    options={cityOptions}
                    onSearch={handleCitySearch}
                    onSelect={handleCitySelect}
                    onChange={(value) => {
                        setFormData(prev => ({ ...prev, city: value }));
                        if (inputFillCheck) setInputFillCheck(false);
                    }}
                    placeholder="Введите ваш город"
                    notFoundContent="Город не найден"
                    filterOption={false}
                    allowClear
                />
            </div>

            {/* Организация и комментарий */}
            <div className="form-group">
                <label className="form-label">Организация (необязательно)</label>
                <input
                    type="text"
                    name="organization"
                    value={formData.organization}
                    onChange={handleFormChange}
                    className="form-input"
                    placeholder="Название вашей организации"
                />
            </div>

            <div className="form-group">
                <label className="form-label">Комментарий к заявке (необязательно)</label>
                <textarea
                    name="comment"
                    value={formData.comment}
                    onChange={handleFormChange}
                    className="form-input form-textarea"
                    placeholder="Дополнительная информация, особые пожелания..."
                    rows="3"
                />
            </div>
        </div>
    );

    // --- Рендер навигации (закреплена внизу) ---
    const renderNavButtons = () => {
        const isBackDisabled = step === 1;

        const isNextDisabled =
            (step === 1 && !material) ||
            (step === 2 && (!supportType || supportType === 'custom_skirt')) ||
            (step === 3 && !selectedModel) ||
            (step === 4 && false) ||
            (step === 5 && false);

        const nextLabel = step === 5 ? (
            <>
                Запросить КП
            </>
        ) : 'Далее >';

        const progress = ((step - 1) / (5 - 1)) * 100;

        return (
            <div className="nav-buttons">
                <div className="progress-bar" style={{ width: `${progress}%` }}> </div>
                <div className="nav-left">
                    <button
                        className="nav-btn nav-btn-back"
                        disabled={isBackDisabled}
                        onClick={goToPrevStep}
                    >
                        Назад
                    </button>
                </div>
                <span className="step-indicator">Шаг {step} / 5</span>
                <div className="nav-right">
                    <button
                        className={`nav-btn nav-btn-next ${loadManyRequest ? "noActiveButton" : ""}`}
                        disabled={isNextDisabled}
                        onClick={step === 5 ? handleSubmitRequest : goToNextStep}
                    >
                        {nextLabel}
                    </button>
                </div>
            </div>
        );
    };

    // --- Основной рендеринг ---
    return (
        <div className={`configurator-silos ${theme}`}>
            <div className={`complexBack ${theme}`}> </div>

            {/* AlertNoCancel для уведомлений */}
            <AlertNoCancel
                showAlertConfirm={showAlertNoCancel}
                setShowAlertConfirm={setShowAlertNoCancel}
                alertConfirmParams={alertNoCancelParams}
            />

            {/* Модалка авторизации */}
            <div className="dropdown-login" style={{ display: showAutorisationForm ? 'block' : 'none' }}>
                <div className="buttonLogin" onClick={authYandex}>
                    <YandexIcon />
                    Войти через Яндекс ID
                </div>
                <div className="buttonLogin" onClick={authGoogle}>
                    <GoogleIcon />
                    Войти через Google ID
                </div>
            </div>
            <div
                onClick={() => setShowAutorisationForm(false)}
                className={`darkSpace ${showAutorisationForm ? 'darkSpaceVisible' : ''}`}
            > </div>

            <div className={`configurator-body ${theme}`}>
                <div className={`configurator-left ${theme}`}>
                    <div className={`configurator-steps ${theme}`}>
                        {[
                            { num: 1, label: 'Материал' },
                            { num: 2, label: 'Тип опоры' },
                            { num: 3, label: 'Габариты' },
                            { num: 4, label: 'Комплектация' },
                            { num: 5, label: 'Заявка' },
                        ].map((s) => {
                            const isActive = step === s.num;
                            const isCompleted = s.num < step; // шаг уже пройден
                            const isClickable = canAccessStep(s.num);
                            const displayNumber = isCompleted ? '✓' : s.num; // галочка для пройденных

                            return (
                                <span
                                    key={s.num}
                                    className={`step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isClickable ? 'clickable' : ''}`}
                                    onClick={() => isClickable && goToStep(s.num)}
                                >
                                    <span className="step-number">{displayNumber}</span> {s.label}
                                </span>
                            );
                        })}
                    </div>

                    <div className={`left-content-wrapper ${theme}`}>
                        {step === 1 && renderStep1()}
                        {step === 2 && renderStep2()}
                        {step === 3 && renderStep3()}
                        {step === 4 && renderStep4()}
                        {step === 5 && renderStep5()}
                    </div>

                    {renderNavButtons()}
                </div>

                <div className={`configurator-right ${theme}`}>
                    {selectedModel ? (
                        <>
                            <div className={`viz-block ${theme}`}>
                                <div className="viz-title">Модель: {getModelName()}</div>
                                <div className={`viz-svg ${theme}`}>
                                    <SilosVisualization
                                        diameter={selectedModel.diameter}
                                        cylinderHeight={selectedModel.cylinderHeight}
                                        totalHeight={selectedModel.totalHeight}
                                        type={getVisualizationType()}
                                        angle={selectedAngle}
                                        showRealValues={showRealValues}
                                        supportType={supportType}
                                        material={material}
                                    />
                                </div>
                            </div>
                            <div className={`specs-block ${theme}`}>
                                <div className="specs-title">СПЕЦИФИКАЦИЯ</div>
                                <div className={`specs-scroll ${theme}`}>
                                    <div className={`specs-grid ${theme}`}>
                                        <div className="spec-item">
                                            <span className="spec-label">Модель</span>
                                            <span className="spec-value">{getModelName()}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Материал</span>
                                            <span className="spec-value">{materials.find(m => m.id === material)?.label || '—'}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Опора</span>
                                            <span className="spec-value">{supportTypes.find(s => s.id === supportType)?.label || '—'}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Диаметр</span>
                                            <span className="spec-value">{showRealValues ? (selectedModel.diameter / 1000).toFixed(1) : '—'} м</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Объём</span>
                                            <span className="spec-value">{showRealValues ? selectedModel.volume : '—'} м³</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Высота цилиндра</span>
                                            <span className="spec-value">{showRealValues ? (selectedModel.cylinderHeight / 1000).toFixed(1) : '—'} м</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Общая высота</span>
                                            <span className="spec-value">{showRealValues ? (selectedModel.totalHeight / 1000).toFixed(1) : '—'} м</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Масса конструкции</span>
                                            <span className="spec-value">{showRealValues ? mass : '—'}</span>
                                        </div>
                                        <div className="spec-item">
                                            <span className="spec-label">Угол раствора</span>
                                            <span className="spec-value">{showRealValues ? selectedAngle : '—'}°</span>
                                        </div>
                                        {step >= 4 && (
                                            <>
                                                <div className="spec-item">
                                                    <span className="spec-label">Группа плотности</span>
                                                    <span className="spec-value">{densityGroup}</span>
                                                </div>
                                                <div className="spec-item">
                                                    <span className="spec-label">Комплектация</span>
                                                    <span className="spec-value">
                                                        {accessories.length > 0 ? accessories.map(id => {
                                                            const opt = accessoryOptions.find(o => o.id === id);
                                                            return opt ? opt.label : id;
                                                        }).join(', ') : '—'}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className={`viz-block ${theme}`} style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <div className="viz-title">Модель: {getModelName()}</div>
                            <div className={`viz-placeholder ${theme}`}>Выберите параметры для визуализации</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}